import { fetchWrapper } from "../utils/fetch-wrapper";



const unitesOrganisationSerivces = {
    getAll,
    getById,
    post,
    update,
    correspondanceunite,
    delete: _delete,
};

function getAll() {
    return fetchWrapper.get(`unites_organisations/`);
}


function getById(id) {
    return fetchWrapper.get(`unites_organisations/${id}`);
  }


  function post(data) {
    return fetchWrapper.post("unites_organisations/", data);
  }
  
  function update(id, params) {
    return fetchWrapper.put(`unites_organisations/${id}`, params);
  }
  
  function _delete(id) {
    return fetchWrapper.delete(`unites_organisations/${id}`);
  }

  function correspondanceunite(data){
    return fetchWrapper.post(`unites_organisations/correspondance`, data);
  }

export default unitesOrganisationSerivces;